<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="子账户管理" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="common-btn btn" slot="right" @click="goAdd" >新增</div>
            </mt-header>
        </div>
		<div class="main-content">
			<div  v-for="item in sellerList" v-bind:key="item.seller_id" @click="onEdit(item.seller_id)" >
				<flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{item.seller_name}}</span></flex-line>
			</div>
		</div>
        
        <empty-record v-if="sellerList && !sellerList.length"></empty-record>
    </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getSellerAccountList } from '../../../api/sellerAccount'
import flexLine from '../../flexLine'
export default {
  name: 'AccountList',
  components: {
    EmptyRecord,
	flexLine
  },
  data () {
    return {
      sellerList: false // 用户列表
    }
  },
  created: function () {
    this.getAccountList()
  },
  methods: {
    getAccountList () {
      Indicator.open()
      getSellerAccountList().then(res => {
        Indicator.close()
        this.sellerList = res.result.seller_list
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    onEdit (sellerId) {
      this.$router.push({ name: 'SellerAccountForm', query: { seller_id: sellerId } })
    },
    goAdd () {
      this.$router.push({ name: 'SellerAccountForm', query: { action: 'add' } })
    }
  }

}
</script>

<style scoped lang="scss">
.common-header{
	.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
}
.main-content{padding:0 $pageSpace;background: #fff}
</style>
